import { DefaultState, IState } from './state';
import { Keys, Types } from './actions/types';
import { IChatMessage, chatResponse } from '../../../model/chatmessage';
import { NormalizedObjectsFactory, INormalizedObjects } from '../../../common/interfaces/INormalizedObject';

const cloneAndAlignAllIds = (state: IState, sub: string): INormalizedObjects<IChatMessage[]> => {

  var chats = {
    byId: { ...state.chatmessages.byId },
    allIds: [...state.chatmessages.allIds]
  }
  if (!chats.byId[sub]) {
    chats.allIds.push(sub)
  }

  return chats;
}

export const reducer = (state: IState = DefaultState(), action: Types): IState => {
  switch (action.type) {
    case Keys.ADDCHATMESSAGE_FULFILLED: {
      let chatmessage: IChatMessage = action.payload;
      let sub = chatmessage.user._id;
      let chats = cloneAndAlignAllIds(state, sub);

      chats.byId[sub] = [...chats.byId[sub], chatmessage];

      return {
        ...state,
        chatmessages: chats
      }
    }
    case Keys.ADDCHATMESSAGE_REJECTED: {
      return {
        ...state
      }
    }
    case Keys.GETCHATMESSAGES_FULFILLED: {
      let resp: chatResponse = action.payload;
      let chats = cloneAndAlignAllIds(state, resp.sub);

      chats.byId[resp.sub] = resp.messages;

      return {
        ...state,
        chatmessages: chats
      }
    }
    case Keys.GETCHATMESSAGES_REJECTED: {
      return {
        ...state,
        chatmessages: NormalizedObjectsFactory()
      }
    }
    case Keys.RECEIVEMESSAGEWEBSOCKET: {
      const { chatmessage, currentUserSub }: { chatmessage: IChatMessage, currentUserSub: string } = action.payload;
      //let chatmessages: Array<IChatMessage> = [...state.chatmessages];
      let sub = chatmessage.user._id;
      let chats = cloneAndAlignAllIds(state, sub);
      let unreads = { ...state.unreadcount };

      if (!chats.byId[sub])
        chats.byId[sub] = [];

      chats.byId[sub] = [...chats.byId[sub], chatmessage];

      //Se il messaggio non � nella chat selezionata, incremento il counter
      if (sub !== currentUserSub) {
        if (!unreads[sub])
          unreads[sub] = { count: 0, date: new Date() };

        unreads[sub].count++;
        unreads[sub].date = new Date();
      }

      return {
        ...state,
        unreadcount: unreads,
        chatmessages: chats
      }
    }
    case Keys.SETASSEEN_FULFILLED: {
      let current = state.unreadcount[action.payload];
      if (!current || current.count === 0)
        return state;
      else {
        let uC = { ...state.unreadcount }
        uC[action.payload] = {
          ...uC[action.payload],
          count: 0
        }
        return {
          ...state,
          unreadcount: uC
        }
      }
    }
    case Keys.GETCHATUNREADCOUNT_FULFILLED: {
      let ps: { _id: string, count: number, date: Date }[] = action.payload;
      let unC = {}
      if (ps) {
        ps.forEach(p => {
          unC[p._id] = {
            count: p.count,
            date: new Date(p.date)
          }
        });
      }
      return {
        ...state,
        unreadcount: unC
      }
    }
    case Keys.GETCHATUNREADCOUNT_REJECTED: {
      return {
        ...state,
        unreadcount: {}
      }
    }
    case Keys.RESETNEWMESSAGERECEIVEDSTATUS: {
      return {
        ...state,
        newMessageReceived: false,
      }
    }
    case Keys.SETNEWMESSAGERECEIVEDSTATUS: {
      return {
        ...state,
        newMessageReceived: true,
      }
    }
    default:
      return state;
  }
}